@if (show) {
  <div class="modal-overlay" (click)="onClose()">
    <div class="modal-content small" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>
          <fa-icon [icon]="faTrash"></fa-icon>
          <span>{{ 'DELETE.TITLE' | translate }}</span>
        </h3>
        <button class="close-btn" (click)="onClose()">
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </div>
      <div class="modal-body">
        <p>{{ 'DELETE.MESSAGE' | translate:{ name: configKey } }}</p>

        @if (impactItems.length > 0) {
          <div class="impact-section">
            <div class="impact-header">
              <fa-icon [icon]="faExclamationTriangle"></fa-icon>
              <span>{{ 'DELETE.IMPACT_TITLE' | translate }}</span>
            </div>
            <ul class="impact-list">
              @for (item of impactItems; track item) {
                <li>{{ item }}</li>
              }
            </ul>
          </div>
        }

        @if (forceCheckboxLabel) {
          <div class="force-delete-section" [class.active]="forceDelete">
            <label class="force-checkbox-label">
              <input type="checkbox" [(ngModel)]="forceDelete" />
              <span>{{ forceCheckboxLabel }}</span>
            </label>
            @if (forceDelete && forceCheckboxWarning) {
              <p class="force-warning">
                <fa-icon [icon]="faExclamationTriangle"></fa-icon>
                {{ forceCheckboxWarning }}
              </p>
            }
          </div>
        }

        <div class="form-actions">
          <app-button [text]="'BUTTON.CANCEL' | translate" variant="secondary" (clicked)="onClose()">
          </app-button>
          <app-button [text]="'BUTTON.DELETE' | translate" variant="danger" [icon]="faTrash" (clicked)="onConfirm()">
          </app-button>
        </div>
      </div>
    </div>
  </div>
}